import * as z from "zod";

export const merchantClaimRankingRowSchema = z.object({
  teamId: z.string(),
  teamName: z.string().nullable(),
  totalClaimValue: z
    .number()
    .describe(
      "Sum of analytics_totals_return_total_value for this merchant's claim-type returns",
    ),
  avgClaimValue: z
    .number()
    .describe(
      "Average analytics_totals_return_total_value across this merchant's claim-type returns",
    ),
  claimCount: z.number().int(),
});

export type MerchantClaimRankingRow = z.infer<
  typeof merchantClaimRankingRowSchema
>;

export const getMerchantClaimRanking = {
  name: "getMerchantClaimRanking" as const,
  input: z.object({
    startDate: z
      .string()
      .describe("Inclusive ISO timestamp lower bound on created_at"),
    endDate: z
      .string()
      .describe("Exclusive ISO timestamp upper bound on created_at"),
  }),
  output: z.object({ merchants: z.array(merchantClaimRankingRowSchema) }),
};
